module.exports = __webpack_public_path__ + "static/media/pound.71c113de.svg";